import {
    FormControl,
    FormLabel,
    Button,
    HStack
} from '@chakra-ui/react';
import Selector from 'components/Selector';
import HelpTip from 'components/HelpTip';
import CustomDialog from './CustomDialog';
import {useState, useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import useCustomToast from 'hooks/useCustomToast';
import {get, isNil} from 'lodash';
import {StyledButton} from 'components/StyledBtn';
import {useUserForexAccountList, editMtUpRebateAccount} from 'hooks/datahook/forex';
import { getErrorMessage } from 'utils/error';
import {useAuth} from '../../hooks/useAuth';

// CRM-758：按 Sub IB 设置"上传给当前用户的佣金"的收款账户（MT4 或 MT5 各一）
export default ({open, onClose, user, nodeId, value, mutate, source = 'MT4'}) => {
    const {isUser} = useAuth();
    const [loading, setLoading] = useState(false);
    const [defaultAccount, setDefaultAccount] = useState(null);
    const isMT4 = source === 'MT4';
    const {data: accounts} = useUserForexAccountList({
        user: user,
        type: 'Rebate',
        source: isMT4 ? 'MT4,MT4s2,MT4s3' : 'MT5'
    });
    const {t} = useTranslation('app');
    const toast = useCustomToast();

    useEffect(() => {
        setDefaultAccount(value);
    }, [value]);

    useEffect(() => {
        if (isNil(defaultAccount)) {
            setDefaultAccount(value);
        }
    }, [defaultAccount]);

    const reset = () => {
        setDefaultAccount(value);
    };

    const onSubmit = async () => {
        try {
            setLoading(true);
            await editMtUpRebateAccount({
                nodeId: Number(nodeId),
                accountId: defaultAccount,
                user: !isUser ? user : null,
            });
            toast.show({
                title: t('updateSuccess'),
                status: 'success',
            });
            mutate && (await mutate());
            onClose();
            setLoading(false);
        } catch (error) {
            setLoading(false);
            toast.show({
                title: t('updateFailed'),
                description: getErrorMessage(error),
                status: 'error',
            });
        }
    };
    return (
        <CustomDialog
            open={open}
            onClose={()=>{
                onClose();
                reset();
            }}
            title={isMT4 ? t('editMt4UpRebateAccount') : t('editMt5UpRebateAccount')}
            actions={
                <HStack>
                    <Button size={'sm'} onClick={() => onClose()}>{t('cancel')}</Button>
                    <StyledButton
                        isLoading={loading}
                        onClick={() => onSubmit()}
                    >
                        {t('submit')}
                    </StyledButton>
                </HStack>
            }
        >
            <FormControl>
                <FormLabel>
                    {isMT4 ? t('mt4UpRebateAccount') : t('mt5UpRebateAccount')}
                    <HelpTip text={t('upRebateAccountTip')} />
                </FormLabel>
                <Selector
                    options={accounts.map((item) => {
                        return {
                            label: `${get(item, 'accountSource')}-${get(
                                item,
                                'login',
                            )}`,
                            value: get(item, 'id'),
                        };
                    })}
                    value={defaultAccount}
                    onChangeValue={(newValue) => setDefaultAccount(newValue)}
                />
            </FormControl>
        </CustomDialog>
    );
};
